import INVENTORY_API_BASE_URL from "../../config/api";
import "./Hologram.css";
import { useState } from "react";
import Axios from "axios";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";
import moment from "moment";
import logUserActivity from "../utils/logUserActivity";

function Hologram() {
  const [listOfHologram, setlistOfHologram] = useState([]);
  const [Quantity, setQuantity] = useState("");
  const [StartingNo, setStartingNo] = useState("");
  const [EndingNo, setEndingNo] = useState("");
  const [Date, setDate] = useState("");
  const [VehicleNo, setVehicleNo] = useState("");
  const maxDate = moment().format("YYYY-MM-DD");

  const createUser = (event) => {
    event.preventDefault();

    if (!Quantity || !StartingNo || !EndingNo || !Date) {
      swal({
        title: "Error",
        text: "All fields are mandatory.",
        icon: "error",
      });
      return;
    }

    if (isNaN(Quantity) || isNaN(StartingNo) || isNaN(EndingNo)) {
      swal({
        title: "Error",
        text: "Quantity, Starting Serial Number, and Ending Serial Number must be numbers.",
        icon: "error",
      });
      return;
    }

    Axios.post(INVENTORY_API_BASE_URL + "/postHologram", {
      Quantity,
      StartingNo,
      EndingNo,
      Date,
      VehicleNo,
    })
      .then(async (response) => {
        if (response.status === 200) {
          setlistOfHologram((prevList) => [
            ...prevList,
            { Quantity, StartingNo, EndingNo, Date, VehicleNo },
          ]);

          await logUserActivity("CREATE_HOLOGRAM", {
            Quantity,
            StartingNo,
            EndingNo,
            Date,
            VehicleNo,
          });

          swal({
            title: "Hologram saved successfully",
            icon: "success",
          }).then(() => {
            setQuantity("");
            setStartingNo("");
            setEndingNo("");
            setDate("");
            setVehicleNo("");
          });
        }
      })
      .catch((error) => {
        console.error("Error saving hologram:", error);
        swal({
          title: "Error",
          text: "Failed to save hologram. Please try again.",
          icon: "error",
        });
      });
  };

  return (
    <main className="hologram-page">
      <div className="hologram-workspace">
        <header className="hologram-hero">
          <div className="hologram-hero-copy">
            <p className="hologram-eyebrow">Inventory / Security labels</p>
            <h1>Hologram registration</h1>
            <p>
              Create a hologram record with its quantity, serial range, issue
              date, and vehicle details.
            </p>
          </div>
          <div className="hologram-hero-badge">
            <span className="hologram-hero-icon" aria-hidden="true">H</span>
            <span>
              <strong>Hologram control</strong>
              <small>Inventory operations</small>
            </span>
          </div>
        </header>

        <section className="hologram-panel" aria-labelledby="hologram-form-title">
          <header className="hologram-panel-heading">
            <div>
              <p className="hologram-section-eyebrow">New record</p>
              <h2 id="hologram-form-title">Hologram details</h2>
              <p>Enter the required batch information before saving.</p>
            </div>
            <span className="hologram-required-note">
              <span aria-hidden="true">*</span> Required fields
            </span>
          </header>

          <div className="hologram-form-body">
            <div className="hologram-guidance">
              <span className="hologram-guidance-icon" aria-hidden="true">01</span>
              <p>
                Add the quantity and serial-number range that belong to this
                hologram batch.
              </p>
            </div>

            <form className="holo hologram-form" onSubmit={createUser}>
              <div className="hologram-fields">
                <div className="hologram-field">
                  <label htmlFor="hologram-quantity">
                    Quantity <span className="hologram-required">*</span>
                  </label>
                  <input
                    id="hologram-quantity"
                    type="number"
                    name="Quantity"
                    required
                    value={Quantity}
                    onChange={(event) => setQuantity(event.target.value)}
                    onWheel={(event) => event.target.blur()}
                  />
                  <small>Number of holograms in this batch.</small>
                </div>

                <div className="hologram-field">
                  <label htmlFor="hologram-date">
                    Issue date <span className="hologram-required">*</span>
                  </label>
                  <input
                    id="hologram-date"
                    type="date"
                    max={maxDate}
                    required
                    value={Date}
                    onChange={(event) => setDate(event.target.value)}
                  />
                  <small>Select a date up to today.</small>
                </div>

                <div className="hologram-field">
                  <label htmlFor="hologram-start">
                    Starting serial number <span className="hologram-required">*</span>
                  </label>
                  <input
                    id="hologram-start"
                    type="number"
                    name="StartingNo"
                    required
                    value={StartingNo}
                    onChange={(event) => setStartingNo(event.target.value)}
                    onWheel={(event) => event.target.blur()}
                  />
                  <small>First serial in the assigned range.</small>
                </div>

                <div className="hologram-field">
                  <label htmlFor="hologram-end">
                    Ending serial number <span className="hologram-required">*</span>
                  </label>
                  <input
                    id="hologram-end"
                    type="number"
                    name="EndingNo"
                    required
                    value={EndingNo}
                    onChange={(event) => setEndingNo(event.target.value)}
                    onWheel={(event) => event.target.blur()}
                  />
                  <small>Last serial in the assigned range.</small>
                </div>

                <div className="hologram-field hologram-field-wide">
                  <label htmlFor="hologram-vehicle">
                    Vehicle number <span className="hologram-optional">(optional)</span>
                  </label>
                  <input
                    id="hologram-vehicle"
                    type="text"
                    name="VehicleNo"
                    value={VehicleNo}
                    onChange={(event) => setVehicleNo(event.target.value)}
                    onWheel={(event) => event.target.blur()}
                    placeholder="Enter vehicle number"
                  />
                </div>
              </div>

              <footer className="hologram-form-footer">
                <p>Review the serial range before saving this record.</p>
                <Button className="holobtn" type="submit">
                  <span aria-hidden="true">＋</span>
                  Save
                </Button>
              </footer>
            </form>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Hologram;
